import {
  Component,
  OnInit,
  Output,
  EventEmitter,
  Input,
  OnChanges,
} from '@angular/core';
import { FieldMapItem, TableSettings } from 'beyond-util';
import { EmisijaCenaService } from './emisija-cena.service';
import * as moment from 'moment';
import { EMISIJA_AZURIRAJ_RASPOREDE_CENAMA } from '../../constants/tooltip-messages';

@Component({
  selector: 'app-emisija-cena-details',
  templateUrl: './emisija-cena-details.component.html',
  styleUrls: ['./emisija-cena-details.component.scss'],
})
export class EmisijaCenaDetailsComponent implements OnInit {
  public datumOdFieldSettings: FieldMapItem;
  public datumDoFieldSettings: FieldMapItem;
  public order: any = {};
  public isEditMode = false;
  public tooltipOptions = {
    placement: 'top',
    'show-delay': '500',
    theme: 'light',
  };
  public emisijeCenaTooltip = { EMISIJA_AZURIRAJ_RASPOREDE_CENAMA };

  constructor(public emisijaCenaService: EmisijaCenaService) {
    this.setSettings();
  }

  get isButtonDisabled() {
    let retVal = false;
    if (!this.order || !this.order.datumOd || !this.order.datumDo) {
      retVal = true;
    }

    return retVal;
  }

  @Input() set orderDatumi(value: any) {
    if (value) {
      this.order = value;
    }
  }

  @Output() update: EventEmitter<any> = new EventEmitter<any>();

  ngOnInit() {}

  setSettings() {
    const helperSettings: TableSettings = new TableSettings(
      this.emisijaCenaService.getEmisijaCenaSettings(),
      'table'
    );

    this.datumOdFieldSettings = helperSettings.getFieldByName('DatumOd');
    this.datumDoFieldSettings = helperSettings.getFieldByName('DatumDo');
  }

  onDatumChange(event) {
    if (event.value) {
      if (event.columnItem.fieldKey === 'datumOd') {
        this.order.datumOd = moment(event.value.start).format('YYYY-MM-DD');
      } else {
        this.order.datumDo = moment(event.value.start).format('YYYY-MM-DD');
      }
    }
  }

  emitUpdate(event) {
    this.update.emit(this.order);
  }
}



// WEBPACK FOOTER //
// ./src/app/components/emisija-cena-details/emisija-cena-details.component.ts